export const beerEmoji = "🍻";
export const puppyEmoji = "🐶";
